import moment from 'moment';
import tz from 'moment-timezone';
import isArray from 'lodash/isArray';
import range from 'lodash/range';
import uniq from 'lodash/uniq';

export const getLocalTimeZone = () => (
  tz.tz.guess()
  || 'America/New_York'
);

export const getDays = () => ([
  'SUN',
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
]);

export const getTimeZoneOptions = () => (
  [
    'America/Anchorage',
    'America/Boise',
    'America/Chicago',
    'America/Denver',
    'America/Detroit',
    'America/Indianapolis',
    'America/Los_Angeles',
    'America/Louisville',
    'America/New_York',
    'America/Phoenix',
    'Pacific/Honolulu',
  ]
    .filter(zone => 
      zone.startsWith('America/') 
      && !zone.includes('Argentina')
      && !zone.includes('Antigua')
      && !zone.includes('Anguilla')
      && !zone.includes('Aruba')
      && !zone.includes('Araguaina')
      && !zone.includes('Asuncion')
      && !zone.includes('Atikokan')
    ).map(zone => ({
      label: zone,
      value: zone,
    }))
);

// Given an array of times, return true if and only if the times are all valid
// each time should conform to the form of {start_time: 'hh:mm a', end_time: 'hh:mm a'}
export const validateAvailabilityTimes = times => {
  if (!times || !isArray(times)) return false;
  const isValid = times.reduce((acc, {start_time, end_time}) => {
      const start = moment(start_time, 'hh:mm a');
      const end = moment(end_time, 'hh:mm a');
      const isValid = end.isAfter(start);
      return acc && isValid;
    }, true);
  return isValid;
};

export const calculateNextAvailabilityDate = providerAvailability => {
  const today = moment();
  const startDate = moment(providerAvailability?.date_range_start);
  const endDate = moment(providerAvailability?.date_range_end);
  const repeatEveryNWeeks = providerAvailability?.repeat_every_period_value || 1;
  const dayAvailabilities = providerAvailability?.day_availabilities || [];
  const daysOfWeek = uniq(dayAvailabilities.flatMap(d => d.day));
  const daysOfWeekNums = daysOfWeek.map(d => getDays().indexOf(d));
  // console.log('DAYS_OF_WEEK', dayAvailabilities, daysOfWeek, daysOfWeekNums, 'START_DATE', startDate.format('YYYY-MM-DD'), 'END_DATE', endDate.format('YYYY-MM-DD'));
  // calculate the next date on which the availability will occur  
  let indexDate = startDate.isBefore(today) ? today : startDate;
  if (indexDate.isAfter(endDate)) indexDate = endDate;
  const nextDayOfWeek = daysOfWeekNums.find(d => d >= indexDate.day());
  let nextDate;
  let weekOffset = (
    moment(indexDate)
    .subtract(providerAvailability?.date_range_start)
    .week()
    % repeatEveryNWeeks
  );
  if (nextDayOfWeek === indexDate.isoWeekday()) {
    nextDate = indexDate.add(weekOffset, 'weeks').clone();
  } else if (nextDayOfWeek > indexDate.isoWeekday()) {
    nextDate = indexDate.add(weekOffset, 'weeks').clone().day(nextDayOfWeek);
  } else {
    nextDate = indexDate.clone().add(weekOffset, 'weeks').day(nextDayOfWeek);
  }
  return nextDate;
};
